module.exports = __webpack_public_path__ + "img/PXL_20230523_141956393.a8a4d1cb.jpg";